import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { TractorType } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/Tractor";
import { TractorProductIntroFormValues } from "../tractorInterface";

export const validationSchema =
  (): Yup.ObjectSchema<TractorProductIntroFormValues> => {
    const { getText } = TextManager;

    return Yup.object().shape({
      tractorType: Yup.mixed<TractorType>().required(
        getText("tractorform.validation.tractortype"),
      ),
      firstRegistered: Yup.number().required(
        getText("tractorform.validation.firstregistered"),
      ),
      brandOrModel: Yup.string().required(
        getText("tractorform.validation.brandormodel"),
      ),
    });
  };
